import React from "react";
import Modal from "../Modal";
import moment from "moment/moment";

const DeleteStatusModal = ({ setUpdateState, data }) => {
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteReasonModal: false,
    }));
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Course Deletion Details</h3>
          <div className="form-group">
            <label>Reason for course deletion</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter the reason"
              value={data?.deleteReason}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Course deletion date</label>
            <input
              type="date"
              className="form-control"
              placeholder="Enter the date"
              value={moment(data?.deleteAt).format("YYYY-MM-DD")}
              disabled
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteStatusModal;
